import './App.css';
import { BrowserView, MobileView } from 'react-device-detect';
import { isMobile } from 'react-device-detect';
import MobileApp from './Mobile/MobileApp';
import DesktopApp from './Desktop/DesktopApp';
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {ProtectedRoute} from "./Components/RequireAuth/RequireAuth";
import MobileLogin from "./Mobile/MobileLogin/MobileLogin";
import DesktopLogin from "./Desktop/DesktopLogin/DesktopLogin";
import {Fragment, useEffect, useState} from "react";
import DesktopRegister from "./Desktop/DesktopRegister/DesktopRegister";
import MobileRegister from "./Mobile/MobileRegister/MobileRegister";
import CourtRules from "./Pages/CourtRules/CourtRules";
import axios from "axios";
import Admin from "./Pages/Admin/Admin";
import AdminUsers from "./Pages/Admin/AdminUsers/AdminUsers";
import AdminUserProfile from "./Pages/Admin/AdminUserProfile/AdminUserProfile";
import AdminBoxes from "./Pages/Admin/AdminBoxes/AdminBoxes";

function App() {

    // const [isAdmin, setIsAdmin] = useState(false);
    // const [isLoaded, setIsLoaded] = useState(false);
    //
    // useEffect(() => {
    //     axios.get(`/api/is_admin/`, {headers: {
    //             'Content-Type': 'application/json',
    //         }, withCredentials: true})
    //         .then(res => {
    //             if (res.data.detail) {
    //                 setIsAdmin(true);
    //             }
    //             setIsLoaded(true);
    //         })
    //         .catch(e => {
    //             console.log(e);
    //             setIsLoaded(true);
    //         })
    // })


    // if (isLoaded && isAdmin) {
    //     return (
    //         <div className="App">
    //             <BrowserRouter>
    //                 <Routes>
    //                     <Route path="/">
    //                         <Route index element={ <ProtectedRoute><Admin /></ProtectedRoute> } />
    //                         <Route path="admin" element={ <Admin /> } />
    //                         <Route path="admin_user_search" element={ <AdminUsers /> } />
    //                         <Route path="admin_user_profile" element={ <AdminUserProfile /> } />
    //                         <Route path="admin_boxes" element={ <AdminBoxes /> } />
    //                         <Route path="*" element={ <Navigate to='admin' /> } />
    //                     </Route>
    //                 </Routes>
    //             </BrowserRouter>
    //         </div>
    //     );
    // } else
        if (isMobile) {
            return (
                <Fragment>
                    <div className="App">
                        <BrowserRouter>
                            <Routes>
                                <Route path="/login" element={<MobileLogin />} />
                                <Route path="/register" element={ <MobileRegister /> } />
                                <Route path="/api/auth/yandex/login/" />
                                <Route path="/api/auth/vk/login/" />
                                <Route path="/court_rules" element={ <CourtRules /> } />
                                <Route path="/*" element={ <ProtectedRoute><MobileApp /></ProtectedRoute>} />
                            </Routes>
                        </BrowserRouter>
                        {/*<MobileApp />*/}
                    </div>
                    <div className={'orientation-warning-container'}>
                        <p className={'orientation-warning-text'}>Пожалуйста, поверните экран.</p>
                    </div>
                </Fragment>
            );
        } else {
            return (
                <div className="App">
                    <BrowserRouter>
                        <Routes>
                            <Route path="/login" element={<DesktopLogin />} />
                            <Route path="/register" element={ <DesktopRegister /> } />
                            <Route path="/api/auth/yandex/login/" />
                            <Route path="/api/auth/vk/login/" />
                            <Route path="/court_rules" element={ <CourtRules /> } />
                            <Route path="/*" element={ <ProtectedRoute><DesktopApp /></ProtectedRoute>} />
                        </Routes>
                    </BrowserRouter>
                    {/*<DesktopApp />*/}
                </div>
            );
        }

}

export default App;
